import { Link } from "react-router-dom";
import { BookOpen, ArrowRight } from "lucide-react";
import SectionHeading from "./SectionHeading";

const BLOG_LINKS = [
  {
    title: "Top 10 MedSpa Treatments in 2025",
    slug: "top-10-medspa-treatments-2025",
    description:
      "Discover the most popular and effective MedSpa treatments trending this year, from Botox and fillers to advanced laser procedures and body contouring.",
  },
  {
    title: "How to Choose the Right MedSpa",
    slug: "how-to-choose-the-right-medical-spa",
    description:
      "Key factors to consider when selecting a MedSpa provider you can trust, including credentials, reviews, consultations, and what questions to ask before booking.",
  },
  {
    title: "MedSpa vs. Day Spa: Key Differences",
    slug: "medspa-vs-day-spa-differences",
    description:
      "Understand the important distinctions between medical spas and traditional day spas, including the types of treatments offered, staff qualifications, and oversight.",
  },
  {
    title: "What to Expect at Your First Visit",
    slug: "what-to-expect-first-medspa-visit",
    description:
      "A step-by-step guide to help you feel prepared and confident for your first MedSpa appointment, covering consultations, treatment plans, and aftercare tips.",
  },
  {
    title: "MedSpa Safety: What Patients Need to Know",
    slug: "medspa-safety-what-patients-need-to-know",
    description:
      "Essential safety tips and red flags to watch for when choosing a provider, including licensing requirements, sanitation standards, and how to verify credentials.",
  },
  {
    title: "Botox vs. Fillers: Which Is Right for You?",
    slug: "botox-vs-fillers-which-injectable-is-right",
    description:
      "Compare these two popular injectables side by side to understand how they work, what they treat, how long results last, and which option best fits your aesthetic goals.",
  },
];

function GuideCard({
  title,
  slug,
  description,
}: {
  title: string;
  slug: string;
  description: string;
}) {
  return (
    <Link
      to={`/blog/${slug}`}
      className="group card-premium flex flex-col p-6 hover:-translate-y-1.5 hover:border-primary/30 transition-all duration-300"
    >
      <div className="w-11 h-11 rounded-2xl bg-primary/10 border border-primary/20 flex items-center justify-center mb-4 group-hover:scale-105 transition-transform">
        <BookOpen className="w-5 h-5 text-primary" />
      </div>
      <h3 className="text-base font-semibold text-foreground group-hover:text-primary transition-colors mb-2">
        {title}
      </h3>
      <p className="text-sm text-muted-foreground leading-relaxed line-clamp-2">
        {description}
      </p>
      <span className="inline-flex items-center gap-1 text-sm font-semibold text-teal-300 mt-4">
        Read guide <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" />
      </span>
    </Link>
  );
}

export default function GuidesSection() {
  return (
    <section className="py-16 lg:py-24">
      <div className="container mx-auto px-4 lg:px-8">
        <SectionHeading
          eyebrow="Guides & Resources"
          title={
            <>
              Guides & <span className="text-gradient-aqua">Resources</span>
            </>
          }
          description="Expert articles to help you navigate the world of MedSpas and aesthetic treatments"
          action={
            <Link
              to="/blog"
              className="hidden sm:inline-flex items-center gap-2 px-5 py-3 rounded-xl border border-white/10 bg-white/5 text-sm font-semibold text-foreground hover:border-primary/30 transition-colors"
            >
              View All
              <ArrowRight className="w-4 h-4" />
            </Link>
          }
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 lg:gap-4">
          {BLOG_LINKS.map((post) => (
            <GuideCard key={post.slug} {...post} />
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/blog"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline"
          >
            View All Articles
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
